// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawer_SideDrawer__KziCT","Open":"SideDrawer_Open__YhB+H","Close":"SideDrawer_Close__REyqD","Logo":"SideDrawer_Logo__h7O9R"};